import HttpSubscriber from './subscriber';
import { Observable } from 'rxjs';

export default class Http {
  constructor(requestOptions) {
    this.setOptions(requestOptions);
  }

  setOptions(requestOptions) {
    this.requestOptions = requestOptions;
  }

  static get(url, options = {}) {
    return Http.raw({...options, ...{ method: 'GET', url }});
  }

  static post(url, data = {}, options = {}) {
    return Http.raw({...options, ...{ method: 'POST', url, data }});
  }

  static put(url, data = {}, options = {}) {
    return Http.raw({...options, ...{ method: 'PUT', url, data }});
  }

  static patch(url, data = {}, options = {}) {
    return Http.raw({...options, ...{ method: 'PATCH', url, data }});
  }

  static delete(url, options = {}) {
    return Http.raw({...options, ...{ method: 'DELETE', url }});
  }

  static raw(options, observable = null) {
    return new Http(options).observe(observable);
  }

  observe(observable = null) {
    if (!observable) {
      return new Observable(observer => new HttpSubscriber(observer, this.requestOptions));
    }

    return observable.susbcribe(observer => new HttpSubscriber(observer, this.requestOptions));
  }
}